import { F0Alert } from '@factorialco/f0-react'

import { SyncIssue } from 'modules/integrations/hooks/SyncContext/issues'

type IssueItemProps = {
  issue: SyncIssue
}

export function IssueItem({ issue }: IssueItemProps) {
  return (
    <F0Alert
      variant="critical"
      title={issue.title}
      description={issue.description}
      link={
        issue.buttonUrl && issue.buttonLabel
          ? { label: issue.buttonLabel, href: issue.buttonUrl }
          : undefined
      }
    />
  )
}
